//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TelephoneInformationInputItem } from './TelephoneInformationInputItem';

export class TestStudentInputItem extends ItemBase {
    FirstName: string | null = null;
    LastName: string | null = null;
    Email: string | null = null;
    AdultStudentParentIndex: number | null = null;
    DateOfBirth: string | null = null;
    Note: string | null = null;
    FaceTimeID: string | null = null;
    SkypeUsername: string | null = null;
    Telephone: TelephoneInformationInputItem | null = null;

    constructor(initializer?: Partial<TestStudentInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestStudentInputItem";
}
